export default __webpack_public_path__ + "static/media/more-cash.69f3a55f.webp";